export const ORDER_STATUS = Object.freeze({
  PENDING: "pending",
  PAID: "paid",
  CANCELED: "canceled",
  UNKNOWN: "unknown",
});

const PAID_ALIASES = new Set([
  "paid",
  "completed",
  "complete",
  "success",
  "succeeded",
  "done",
  "processed",
  "approved",
  "settled",
]);

const CANCELED_ALIASES = new Set([
  "canceled",
  "cancelled",
  "expired",
  "rejected",
  "failed",
  "declined",
  "voided",
]);

const PENDING_ALIASES = new Set([
  "pending",
  "new",
  "created",
  "waiting",
  "open",
  "active",
  "in_progress",
  "processing",
]);

export function mapBackendStatus(rawSlug) {
  const slug = String(rawSlug || "")
    .toLowerCase()
    .trim();

  if (!slug) return ORDER_STATUS.PENDING;
  if (PAID_ALIASES.has(slug)) return ORDER_STATUS.PAID;
  if (CANCELED_ALIASES.has(slug)) return ORDER_STATUS.CANCELED;
  if (PENDING_ALIASES.has(slug)) return ORDER_STATUS.PENDING;

  return ORDER_STATUS.UNKNOWN;
}

export function getOrderStatus(order) {
  return mapBackendStatus(order?.status?.slug);
}

export function isTerminalStatus(status) {
  return status === ORDER_STATUS.PAID || status === ORDER_STATUS.CANCELED;
}
